<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_5615)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.80534 10.6506C5.8047 10.8253 5.8047 11.0094 5.8047 11.2034V14.7966C5.8047 16.6822 5.8047 17.625 6.39049 18.2108C6.97628 18.7966 7.91908 18.7966 9.8047 18.7966H15.1953C17.0809 18.7966 18.0237 18.7966 18.6095 18.2108C19.1953 17.625 19.1953 16.6822 19.1953 14.7966V11.2034C19.1953 11.0339 19.1953 10.872 19.1949 10.7173L13.9187 13.7983L13.8943 13.8126C13.6693 13.944 13.4588 14.067 13.2699 14.1535C13.0601 14.2495 12.8282 14.3248 12.5572 14.3248C12.2862 14.3248 12.0542 14.2495 11.8444 14.1535C11.6556 14.067 11.445 13.944 11.2201 13.8126L11.1956 13.7983L5.80534 10.6506ZM5.87041 9.06742L11.9016 12.5894C12.1595 12.7399 12.3094 12.8266 12.4274 12.8806C12.4808 12.9051 12.5129 12.9157 12.5314 12.9205C12.5473 12.9247 12.554 12.9248 12.5572 12.9248C12.5604 12.9248 12.567 12.9247 12.583 12.9205C12.6014 12.9157 12.6335 12.9051 12.687 12.8806C12.8049 12.8266 12.9549 12.7399 13.2127 12.5894L19.1369 9.12994C19.0693 8.52013 18.9236 8.10332 18.6095 7.78919C18.0237 7.2034 17.0809 7.2034 15.1953 7.2034H9.8047C7.91908 7.2034 6.97628 7.2034 6.39049 7.78919C6.08721 8.09247 5.94095 8.49145 5.87041 9.06742Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_5615">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
